import React from "react";
import CreateCommitteeHeader from "./components/CreateCommitteeHeader";
import CreateCommitteeForm from "./components/CreateCommitteeForm";
import { useCommitteeById } from "@hooks/procurements/committee/useCommitteeById";

export default function CreateNewCommittee() {
  const { committeeState } = useCommitteeById();

  return (
    <div className="container-96 pt-10">
      <CreateCommitteeHeader committeeState={committeeState} />
      <CreateCommitteeForm committeeState={committeeState} />
    </div>
  );
}
